/* Cart drawer "Don't miss these" rail — arrows and Add buttons.
 *
 * Loaded once from layout/theme.liquid, on every page, whether or not the cart
 * has anything in it. It used to be an inline <script> inside
 * snippets/maahi-cart-recs.liquid, which failed in two ways:
 *
 *   1. The snippet renders nothing when the cart is empty, so on a fresh visit
 *      the script never reached the page at all. Adding the first item then
 *      brought in the rail's markup but no behaviour.
 *   2. The drawer re-renders through innerHTML, and script tags inserted that
 *      way are never executed.
 *
 * Every listener is delegated from document, so it survives each re-render of
 * the rail without being reattached.
 */
(function () {
  if (window.__maahiCartRecsBound) return;
  window.__maahiCartRecsBound = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function railOf(el) {
    return el.closest('[data-maahi-cart-recs]');
  }

  function step(track) {
    var card = track.querySelector('.maahi-cart-recs__card');
    return (card ? card.offsetWidth : 116) + 9;
  }

  /* Page by a full row, so with six suggestions and four in view one click
     brings the remaining two into sight. */
  function pageBy(track) {
    var s = step(track);
    return Math.max(1, Math.round(track.clientWidth / s)) * s;
  }

  function syncArrows(rail) {
    if (!rail) return;
    var track = rail.querySelector('[data-recs-track]');
    if (!track) return;
    var prev = rail.querySelector('[data-recs-prev]');
    var next = rail.querySelector('[data-recs-next]');
    var max = track.scrollWidth - track.clientWidth - 1;
    if (prev) prev.disabled = track.scrollLeft <= 0;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  function syncAll() {
    document.querySelectorAll('[data-maahi-cart-recs]').forEach(syncArrows);
  }

  /* Touch only. On a mouse or trackpad the first click should still open the
     product — a two-step gate there would just be friction, and it would change
     desktop behaviour, which is out of scope. `hover: none` is the standard
     signal for "this pointer cannot hover", i.e. a finger. */
  function isTouchPointer() {
    return window.matchMedia && window.matchMedia('(hover: none)').matches;
  }

  function clearPeek(except) {
    document.querySelectorAll('.maahi-cart-recs__card.is-peeking').forEach(function (c) {
      if (c !== except) c.classList.remove('is-peeking');
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    /* ── Quick Look gate ──────────────────────────────────────────────────
       First tap on a suggestion reveals the veil and goes nowhere; the second
       tap follows the link. Placed before the arrow and add handlers but scoped
       to .maahi-cart-recs__media, so the "+" button and the arrows — which sit
       outside that link — are never swallowed and still work on one tap.

       event.detail === 0 means the activation came from the keyboard rather
       than a pointer, so Enter on a focused card still opens it directly. */
    var media = target.closest('.maahi-cart-recs__media');
    if (media && isTouchPointer() && event.detail !== 0) {
      var card = media.closest('.maahi-cart-recs__card');
      if (card && !card.classList.contains('is-peeking')) {
        event.preventDefault();
        clearPeek(card);
        card.classList.add('is-peeking');
        return;
      }
      /* Already peeking — let the click through to the link. */
    } else if (!target.closest('.maahi-cart-recs__card')) {
      /* Tapped anywhere else: put the veils away. */
      clearPeek(null);
    }

    var arrow = target.closest('[data-recs-prev], [data-recs-next]');
    if (arrow) {
      event.preventDefault();
      var rail = railOf(arrow);
      var track = rail && rail.querySelector('[data-recs-track]');
      if (!track) return;
      var dir = arrow.hasAttribute('data-recs-prev') ? -1 : 1;
      track.scrollBy({ left: dir * pageBy(track), behavior: 'smooth' });
      return;
    }

    var add = target.closest('[data-recs-add]');
    if (!add || add.disabled) return;

    event.preventDefault();
    add.disabled = true;
    add.classList.add('is-adding');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(add.dataset.variantId), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (t) {
            throw new Error('cart/add ' + response.status + ': ' + t.slice(0, 200));
          });
        }
        return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        /* No `sections`: component-cart-items re-renders itself when they are
           absent, and cart-drawer opens on the same event. */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'maahi-cart-recs',
            data: { source: 'maahi-cart-recs', itemCount: 1 }
          }
        }));
      })
      .catch(function (error) {
        console.error('[maahi-cart-recs]', error);
        add.disabled = false;
        add.classList.remove('is-adding');
      });
  });

  /* Swiping the rail dismisses any open veil: the tap that opened it was almost
     certainly the start of that swipe. */
  document.addEventListener('scroll', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-recs-track]')) {
      clearPeek(null);
    }
  }, true);

  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (track && track.matches && track.matches('[data-recs-track]')) {
      syncArrows(track.closest('[data-maahi-cart-recs]'));
    }
  }, true);

  /* Re-sync after the drawer swaps in fresh markup. */
  document.addEventListener('cart:update', function () {
    setTimeout(syncAll, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
